import React, { useEffect, useMemo, useState } from "react";
import CustomTable from "../../ui/custom-table";
import { SetPopupReducerData } from "../../store/reducer/PopupReducer";
import { useDispatch, useSelector } from "react-redux";
import { fetchInvitedUsers, UpdateUserInvite } from "../../api/api";
import { formatTime } from "../../utils/common";

function InviteUser() {
  const dispatch = useDispatch();
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [permissions, setPermissions] = useState([]);
  const [alerts, setAlerts] = useState([]);
  const { user_id, organization_id } = useSelector(
    (state) => state?.authUser?.data?.data
  );
  const { showModal } = useSelector((state) => state?.PopupReducer?.modal);

  // fetch users
  const fecthInvites = async () => {
    try {
      setLoading(true);
      const res = await fetchInvitedUsers(user_id, organization_id);
      setData(res?.data?.data || []);
    } catch (error) {
      console.log("error", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fecthInvites();
  }, []);

  useEffect(() => {
    if (showModal === false) {
      fecthInvites();
    }
  }, [showModal]);

  const columns = useMemo(
    () => [
      { accessorKey: "name", header: "Name" },
      { accessorKey: "invite_status", header: "Invite Status" },
      { accessorKey: "email", header: "Email Id" },
      { accessorKey: "mobile_no", header: "Phone no." },
      {
        accessorKey: "updated_at",
        header: "Date",
        Cell: ({ cell }) => formatTime(cell.getValue()),
      },
    ],
    []
  );

  const handleAddClick = () => {
    dispatch(
      SetPopupReducerData({
        modalType: "InviteUser",
        showModal: true,
      })
    );
  };

  // fetch permissions + alerts
  useEffect(() => {
    const fetchPermissionsAndAlerts = async () => {
      try {
        const permissionsResponse = await fetch(
          "https://us2.sourcesoftsolutions.com:8048/permission-types",
          {
            method: "GET",
            headers: {
              "Content-Type": "application/json",
              Authorization: "Bearer test123securetoken",
            },
          }
        );
        const permissionsData = await permissionsResponse.json();
        setPermissions(permissionsData?.data?.data || []);

        const alertsResponse = await fetch(
          "https://us2.sourcesoftsolutions.com:8048/action-types",
          {
            method: "GET",
            headers: {
              "Content-Type": "application/json",
              Authorization: "Bearer test123securetoken",
            },
          }
        );
        const alertsData = await alertsResponse.json();
        setAlerts(alertsData?.data || []);
      } catch (error) {
        console.error("Error fetching permissions or alerts:", error);
      }
    };

    fetchPermissionsAndAlerts();
  }, []);

  // toggle handler
  const handleToggleChange = async ({ userId, type, valueId, checked }) => {
    try {
      const user = data.find((u) => u._id === userId);
      if (!user) {
        console.error("User not found for id:", userId);
        return;
      }

      const updatedRow = { ...user };

      if (type === "permission") {
        let updatedPermissions = updatedRow.permissions || [];
        if (checked) {
          if (!updatedPermissions.includes(valueId)) {
            updatedPermissions = [...updatedPermissions, valueId];
          }
        } else {
          updatedPermissions = updatedPermissions.filter(
            (id) => id !== valueId
          );
        }
        updatedRow.permissions = updatedPermissions;
      } else if (type === "alert") {
        let updatedActions = updatedRow.action_types || [];
        if (checked) {
          if (!updatedActions.includes(valueId)) {
            updatedActions = [...updatedActions, valueId];
          }
        } else {
          updatedActions = updatedActions.filter((id) => id !== valueId);
        }
        updatedRow.action_types = updatedActions;
      }

      // ✅ Build clean payload (only required fields)
      const payload = {
        _id: updatedRow._id,
        name: updatedRow.name,
        email: updatedRow.email,
        mobile_no: updatedRow.mobile_no,
        // invite_status: updatedRow.invite_status,
        // organization_id: updatedRow.organization_id,
        // user_id: updatedRow.user_id,
        stage_no: updatedRow.stage_no,
        // created_at: updatedRow.created_at,
        // updated_at: updatedRow.updated_at,
        // invited_by: updatedRow.invited_by,
        permissions: updatedRow.permissions || [],
        action_types: updatedRow.action_types || [],
      };

      console.log("Payload being sent:", JSON.stringify(payload, null, 2));

      await UpdateUserInvite(userId, payload);

      // Update local state
      setData((prev) => prev.map((u) => (u._id === userId ? updatedRow : u)));
    } catch (error) {
      console.error("Error updating invite:", error);
    }
  };

  return (
    <aside className="mainSection">
      <CustomTable
        columns={columns}
        data={data}
        loading={loading}
        onAddClick={handleAddClick}
        addButtonLabel="Invite User"
        enableRowExpansion
        permissions={permissions}
        alerts={alerts}
        handleToggleChange={handleToggleChange}
      />
    </aside>
  );
}

export default InviteUser;
